import React, { useCallback, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useSmoothHeight } from 'shared/hooks';

import cls from './TasksGrouper.module.css';
import { Icon } from '../../../../components/newUI/Icon/Icon';
import { useAppSelector } from '../../../../store';
import { useGetFormattedGrouperTitle } from '../../hooks/useGetFormattedGrouperTitle';

interface TasksGrouperProps {
    children: React.ReactNode;
    isEmpty: number;
    initialCollapsing: boolean;
    grouperTitle?: string;
    classes?: string;
}

export const TasksGrouper = (props: TasksGrouperProps) => {
    const { t } = useTranslation();
    const {
        grouperTitle = t('TasksGrouper.props.default_title'),
        isEmpty,
        initialCollapsing,
        children,
        classes,
    } = props;

    const { isCollapsedTabsInList, isExpandedTabsInList } = useAppSelector(
        (state) => state.tasksInformationReducer
    );
    const [isCollapsed, setIsCollapsed] = useState(initialCollapsing);
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const { contentHeight } = useSmoothHeight({ children, contentRef, isCollapsed });

    const { formattedTitle } = useGetFormattedGrouperTitle(grouperTitle);

    const onClickHandler = useCallback(() => {
        setIsCollapsed(!isCollapsed);
    }, [isCollapsed]);

    useEffect(() => {
        if (isCollapsedTabsInList === true) {
            setIsCollapsed(isCollapsedTabsInList);
        }
        if (isExpandedTabsInList === true) {
            setIsCollapsed(false);
        }
    }, [isCollapsedTabsInList, isExpandedTabsInList]);

    return (
        <div className={classNames(cls.TasksGrouper, [classes])}>
            <header className={cls.TasksGrouper_header} onClick={onClickHandler}>
                <h3 className={cls.title}>{formattedTitle}</h3>
                {Boolean(isEmpty) && (
                    <div
                        className={classNames(cls.arrow, {
                            [cls.openArrow]: isCollapsed,
                        })}
                    >
                        <Icon iconName="selectArrow" fill="#818998" />
                    </div>
                )}
            </header>
            <div
                className={classNames(cls.TasksGrouper_Content_Wrapper, {
                    [cls.TasksGrouper_Content_Wrapper_collapsed]: isCollapsed,
                })}
                ref={containerRef}
                style={{
                    height: contentHeight === '2px' ? '0px' : contentHeight,
                }}
            >
                <div ref={contentRef} className={cls.Content__container}>
                    {children}
                </div>
            </div>
        </div>
    );
};
